import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '../common/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MuiDialogActions from '@material-ui/core/DialogActions';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import TextField from '@material-ui/core/TextField';
import dialogStyles from './styles';
import { login, registration, getCountriesList } from '../../actions/login';
import { useDispatch } from 'react-redux'
import { withRouter } from 'react-router-dom';
import Loader from '../common/Loader';
import FormValidator from '../../utils/validator';
import { toast } from 'react-toastify';
import { connect } from "react-redux";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});


const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const Register = (props) => {
  const { classes, handleClose } = props;
  const [countries, setCountries] = useState([]);
  useEffect(() => {
    getCountriesList().then((response) => {
      setCountries(response.data.details.countries);
    })
  }, []);

  const [user, setUser] = useState({
    code: "+91",
    mobileNo: "",
    emailId: "",
    name: "",
    password: "",
    confirmPassword: "",
    dpUrl: "",
    countryId: 1,
    country: "",

    // code:"+91",
    // mobileNo:"7799802045",
    // emailId:"sarath.anagha@gmail.com",
    // name:"Sarath Chandra",
    // password: window.btoa("enjoyfresh"),
    // confirmPassword: window.btoa("enjoyfresh"),
    // dpUrl:"",
    // countryId: 1
  });
  const schema = [
    {
      field: 'mobileNo',
      method: ['matches'],
      args: [/^\d{10}$/],
      validWhen: true,
      message: 'Enter a valid mobile number.',
    },
    {
      field: 'emailId',
      method: ['isEmail'],
      validWhen: true,
      message: 'Enter a valid email.',
    },
    {
      field: 'name',
      method: ['isEmpty'],
      validWhen: false,
      message: 'Name is required.',
    },
    {
      field: 'password',
      method: ['isEmpty'],
      validWhen: false,
      message: 'Password is required.',
    },
    {
      field: 'password',
      method: ['matches'],
      args: [/^.*(?=.{8,})(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%&]).*$/],
      validWhen: true,
      message: 'Please enter secure and strong password.',
    },
    {
      field: 'confirmPassword',
      method: ['isEmpty'],
      validWhen: false,
      message: 'Confirm Password is required.',
    },
    {
      field: 'country',
      method: ['isEmpty'],
      validWhen: false,
      message: 'Select Country Code',
    }
  ];


  const [errors, setErrors] = useState(null);
  const validator = new FormValidator(schema);
  const [isLoading, setLoading] = useState(false);



  const handleChange = (key, e) => {
    setUser({
      ...user,
      [key]: e.target.value
    })

  }


  const registerUser = () => {
    const err = validator.validate({ ...user });
    setErrors(err);
    if (!err.isValid) {
      return;
    }
    setLoading(true);
    var usercountry = (user.country).split(',');
    const useDet = {
      code: usercountry[2],
      mobileNo: user.mobileNo,
      emailId: user.emailId,
      name: user.name,
      password: user.password,
      confirmPassword: user.confirmPassword,
      dpUrl: user.dpUrl,
      countryId: usercountry[0],
      countryName: usercountry[1],
    };
    // console.log(useDet);
    registration(useDet, (message, isError) => {
      const method = isError ? 'error' : 'success';
      toast[method](message);
      setLoading(false);
      if (!isError) {
        handleClose();
      }
    })
  };
  //console.log(errors)
  //console.log(user.country);

  return (
    <div className={classes.container}>
      {isLoading && <Loader />}

      <TextField
        label="Full Name"
        name="name"
        onChange={(e) => handleChange('name', e)}
        variant="outlined"
        classes={{ root: classes.input }}
        value={user.name}
        error={errors && errors.name && errors.name.isInvalid}
        helperText={errors && errors.name && errors.name.isInvalid && errors.name.message}
      />
      <TextField
        label="Email"
        name="emailid"
        placeholder="Enter Email"
        onChange={(e) => handleChange('emailId', e)}
        variant="outlined"
        classes={{ root: classes.input }}
        value={user.emailId}
        error={errors && errors.emailId && errors.emailId.isInvalid}
        helperText={errors && errors.emailId && errors.emailId.isInvalid && errors.emailId.message}
      />
      <TextField
        label=" Phone Number"
        name="mobileNo"
        placeholder="Enter Phone Number"
        onChange={(e) => handleChange('mobileNo', e)}
        variant="outlined"
        classes={{ root: classes.input }}
        value={user.mobileNo}
        error={errors && errors.mobileNo && errors.mobileNo.isInvalid}
        helperText={errors && errors.mobileNo && errors.mobileNo.isInvalid && errors.mobileNo.message}
      />
      <TextField
        label=" Create Password"
        type="password"
        name="password"
        placeholder="Create Password"
        onChange={(e) => handleChange('password', e)}
        variant="outlined"
        classes={{ root: classes.input }}
        value={user.password}
        error={errors && errors.password && errors.password.isInvalid}
        helperText={errors && errors.password && errors.password.isInvalid && errors.password.message}
      />
      <div style={{ width: "50%", paddingTop: "8px" }}>
        <TextField
          label=" Confirm Password"
          type="password"
          name="confirmPassword"
          placeholder="Confirm Password"
          onChange={(e) => handleChange('confirmPassword', e)}
          variant="outlined"
          className="MuiFormControl-root MuiTextField-root Connect(Register)"
          value={user.confirmPassword}
          error={errors && errors.confirmPassword && errors.confirmPassword.isInvalid}
          helperText={errors && errors.confirmPassword && errors.confirmPassword.isInvalid && errors.confirmPassword.message}
        />
        {((user.password && user.confirmPassword) && (user.password !== user.confirmPassword)) ? <div className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error" style={{ color: 'red', fontSize: '12px' }}> Confirm password should match with password</div> : ''}
      </div>
      <TextField
        label=" Do you have a refferal code?"
        placeholder="Enter refferal code"
        //onChange={(e) => handleChange('', e)}
        variant="outlined"
        classes={{ root: classes.input }}
      />
      <FormControl className={classes.formControl}>
        <InputLabel shrink id="demo-simple-select-placeholder-label-label">
        </InputLabel>
        <Select
          labelId="demo-simple-select-placeholder-label-label"
          id="demo-simple-select-placeholder-label"
          name="country"
          variant="outlined"
          value={user.country}
          onChange={(e) => handleChange("country", e)}
          displayEmpty
          classes={{ select: classes.inputRoot }}
          error={errors && errors.country && errors.country.isInvalid}
        >
          <MenuItem value="">
            <em>Select Country</em>
          </MenuItem>
          {countries.map((option) => (
            <MenuItem key={option.countryId} value={`${option.countryId},${option.countryName},${option.countryCode}`}>
              {option.countryName}
            </MenuItem>
          ))}
        </Select>
        <div style={{ color: 'red' }}>{errors && errors.country && errors.country.isInvalid && errors.country.message}</div>
      </FormControl>

      <div className={classes.register}>
        <Button label={'Sign Up'} onClick={registerUser} color="primary" />
      </div>
    </div>
  )
}
const Reg = connect(store => store)(Register);
const SignUp = withStyles(dialogStyles)(Reg);

const Login = withRouter((props) => {
  const { classes, handleClose, history } = props;
  const dispatch = useDispatch()
  const schema = [
    {
      field: 'login',
      method: ['isEmpty'],
      validWhen: false,
      message: 'Username is required.',
    },
    {
      field: 'password',
      method: ['isEmpty'],
      validWhen: false,
      message: 'Password is required.',
    }
  ];
  const validator = new FormValidator(schema);
  const [credentials, setCredentials] = React.useState({
    login: '',
    password: ''
    // login: '8885880284',
    // password: 'MTIzNDU2'
  });
  const [isLoading, setLoading] = useState(false);
  const [errors, setErrors] = useState(null);
  const handleChange = (e, name) => {
    setCredentials({
      ...credentials,
      [name]: e.target.value
    })
  };

  const signIn = () => {
    const err = validator.validate(credentials);
    setErrors(err);
    if (!err.isValid) {
      return;
    }
    setLoading(true);
    dispatch(login(credentials, history, (message, isError) => {
      const method = isError ? 'error' : 'success';
      toast[method](message);
      setLoading(false);
    }))
  };
  // console.log(errors);
  return (<div className={classes.container1}>
    {isLoading && <Loader />}
    <TextField
      label="Email / Mobile No"
      name="name"
      onChange={(e) => handleChange(e, 'login')}
      variant="outlined"
      classes={{ root: classes.loginInput }}
      value={credentials.login}
      error={errors && errors.login && errors.login.isInvalid}
      helperText={errors && errors.login && errors.login.isInvalid && errors.login.message}
    />
    <TextField
      label="Password"
      name="password"
      onChange={(e) => handleChange(e, 'password')}
      variant="outlined"
      type="password"
      classes={{ root: classes.loginInput }}
      value={credentials.password}
      error={errors && errors.password && errors.password.isInvalid}
      helperText={errors && errors.password && errors.password.isInvalid && errors.password.message}
    />
    <div className={classes.signin}>
      <Button label={'Sign In'} onClick={signIn} color="primary" />
    </div>
  </div>
  )
})

const SignIn = withStyles(dialogStyles)(Login);


const CustomizedDialogs = (props) => {
  const { classes } = props;
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button size="small"
        // label="Admin Login / Sign Up"
        label="Admin Login"
        className={'ml-auto login'} onClick={handleClickOpen}>
        Login
      </Button>
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} scroll={'body'} >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            centered
          >
            <Tab label="Login" />
            {/* <Tab label="Sign Up" /> */}
          </Tabs>
        </DialogTitle>
        <DialogContent dividers>
          {value === 0 && <SignIn handleClose={handleClose} />}
          {value === 1 && <SignUp handleClose={handleClose} />}
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default withStyles(dialogStyles)(CustomizedDialogs);
